import crypto from "crypto";

export const generateHashMac = (key: string, baseString: string): string =>
  crypto.createHmac("sha256", key).update(baseString).digest("base64");
